{
  "title": "Solicitudes de horario",
  "description": "Revise las solicitudes de horario de los clientes y abra franjas cuando pueda atenderlas",
  "searchPlaceholder": "Buscar solicitudes de horario...",
  "emptyTitle": "Sin solicitudes de horario",
  "emptyDescription": "Cuando los clientes soliciten horarios no disponibles, sus solicitudes aparecerán aquí.",
  "approve": "Aprobar",
  "decline": "Rechazar",
  "columns": {
    "customer": "Cliente",
    "service": "Servicio",
    "provider": "Proveedor",
    "date": "Fecha",
    "time": "Hora",
    "status": "Estado",
    "created": "Creado"
  },
  "dialog": {
    "approveTitle": "Aprobar solicitud de horario",
    "rejectTitle": "Rechazar solicitud de horario",
    "description": "{{customer}} solicitó {{date}} a las {{time}} para {{service}}.",
    "customerFallback": "Cliente",
    "serviceFallback": "un servicio",
    "oneOffTitle": "Puntual (solo esta fecha)",
    "oneOffDescription": "Abre la franja solo para la fecha solicitada.",
    "recurringTitle": "Recurrente (cada semana)",
    "recurringDescription": "Agrega este horario al calendario semanal del proveedor.",
    "rejectReasonLabel": "Motivo (opcional)",
    "rejectReasonPlaceholder": "Indique al cliente por qué este horario no está disponible",
    "customerNote": "Nota del cliente: {{note}}",
    "approveSuccess": "Franja abierta — se notificará al cliente para reservar",
    "rejectSuccess": "Solicitud rechazada",
    "actionFailed": "Error en la acción",
    "approveConfirm": "Aprobar y abrir franja",
    "rejectConfirm": "Rechazar solicitud"
  }
}
